import * as PapelService from '@/modules/system/papeis/papeis.service';
import Links from '@/shared/constants/navegacao';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { ReadPapelDto, CreatePapelDto, UpdatePapelDto, ReadModuloDto } from '@/api.types';
import { SubmitHandler, useForm } from 'react-hook-form';
import { TabelaDePermissoes } from '../components/papel.table';
import { Tabelas } from '@/shared/constants/tables';
import { toast } from 'react-toastify';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function PermissoesEditPage() {
  const { register, handleSubmit, reset, getValues, setValue } = useForm<ReadPapelDto>();
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);

  const id = params.id ? Number(params.id) : 0;

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Papeis_Criar, onClick: () => { } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  useEffect(() => {
    if (id > 0)
      PapelService
        .readPapel(0, 1, id)
        .then((result) => {
          if (result) {
            const p = result[0][0];
            p.modulos = p.modulos?.sort((a, b) => Number(a.modulo.role) - Number(b.modulo.role))
            reset(p);
          }
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
  }, []);

  const onSubmit: SubmitHandler<CreatePapelDto | ReadPapelDto> = (data, e) => {
    e?.preventDefault();

    if (id) {
      PapelService.updatePapel(data as UpdatePapelDto, id)
        .then(() => {
          toast.success("Papel Salvo");
          navigate(`${Links.Papeis_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        });
    }
    else {
      PapelService.createPapel(data as CreatePapelDto)
        .then(() => {
          toast.success("Papel Criado");
          navigate(`${Links.Papeis_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        });
    }
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    PapelService.deletePapel(id)
      .then(() => {
        toast.success("Papel Removido.");
        navigate(`${Links.Papeis_Index}`);
      })
      .catch((res) => {
        toast.error(String(res));
      });
  };

  function handleChangePermissoes(lista: ReadModuloDto[]): void {
    setValue('modulos', lista);
  }

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Papel</h3>
          <span className="blockquote-footer pb-4 text-end">
            Os papéis são definidos como módulos e divididos em níveis [SEM ACESSO, LER, CRIAR, ATUALIZAR E REMOVER].
          </span>
        </div>
      </div>
      <hr />

      <form onSubmit={(event) => { void handleSubmit(onSubmit)(event); }}>
        <div className="row">
          <div className="mb-4 col-md-4">
            <label htmlFor="nome" className="form-label">
              Nome:
            </label>
            <input
              id="nome"
              title="Nome do papel"
              type="text"
              className="form-control"
              required
              {...register('nome')}
            />
          </div>

          <TabelaDePermissoes
            dtoModules={getValues()?.modulos}
            handleSave={handleChangePermissoes}
          />

          <EditadoPorRodape dados={{ editadoPor: getValues().editadoPor, editadoEm: getValues().editadoEm }} />

          <div>
            <button type="submit" className="btn btn-success">
              {id > 0 ? 'Salvar' : 'Cadastrar'}
            </button>
            {id > 0 && (
              <button
                type="button"
                className="btn btn-danger ms-5"
                onClick={() => setModalExcluirShow(true)}
              >
                Excluir
              </button>
            )}
          </div>

        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.papel}
        idRegistro={id}
      ></ModalHistorico>
    </>
  );
}
